import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCompanyProductsApi,
  createCompanyProductApi,
  updateCompanyProductApi,
  deleteCompanyProductApi,
} from "./companyProductApi";

// GET
export const getCompanyProducts = createAsyncThunk(
  "companyProduct/getCompanyProducts",
  async ({ page, limit, search }, thunkAPI) => {
    try {
      const res = await getCompanyProductsApi({ page, limit, search });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// CREATE
export const createCompanyProduct = createAsyncThunk(
  "companyProduct/createCompanyProduct",
  async (data, thunkAPI) => {
    try {
      const res = await createCompanyProductApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// UPDATE
export const updateCompanyProduct = createAsyncThunk(
  "companyProduct/updateCompanyProduct",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateCompanyProductApi(id, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// DELETE
export const deleteCompanyProduct = createAsyncThunk(
  "companyProduct/deleteCompanyProduct",
  async (id, thunkAPI) => {
    try {
      await deleteCompanyProductApi(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const slice = createSlice({
  name: "companyProduct",
  initialState: {
    products: [],
    total: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyProducts.fulfilled, (state, action) => {
        state.products = action.payload?.items || [];
        state.total = action.payload?.total || 0;
      })
      .addCase(deleteCompanyProduct.fulfilled, (state, action) => {
        state.products = state.products.filter(p => p.id !== action.payload);
      });
  },
});

export default slice.reducer;